/* custom-collection.js
   Card thumbnail slideshow cho section Custom Collection.
   Dùng transform: translateX để cách ly với drag của Embla slider ngoài.
   Hành vi: autoplay (>1 ảnh) + mũi tên prev/next + pause-on-hover/focus/touch
   + chỉ chạy khi hiển thị (IntersectionObserver) + reinit trong Theme Editor. */
(function () {
  'use strict';

  var AUTOPLAY_MS = 3500;
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initThumbs(slider) {
    if (slider.dataset.thumbsInit === 'true') return;
    slider.dataset.thumbsInit = 'true';

    var track = slider.querySelector('.custom-card-thumbs__track');
    var slides = slider.querySelectorAll('.custom-card-thumbs__slide');
    if (!track || slides.length <= 1) return; // 1 ảnh: để tĩnh

    var index = 0;
    var total = slides.length;
    var timer = null;

    function goTo(i) {
      index = (i + total) % total;
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
    }
    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }

    function start() {
      if (prefersReduced || timer) return;
      timer = setInterval(next, AUTOPLAY_MS);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function restart() { stop(); start(); }

    function onNav(fn) {
      return function (e) {
        e.preventDefault();
        e.stopPropagation();
        fn();
        restart();
      };
    }

    var prevBtn = slider.querySelector('.custom-card-thumbs__nav--prev');
    var nextBtn = slider.querySelector('.custom-card-thumbs__nav--next');
    if (prevBtn) prevBtn.addEventListener('click', onNav(prev));
    if (nextBtn) nextBtn.addEventListener('click', onNav(next));

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);
    slider.addEventListener('touchstart', stop, { passive: true });

    slider._thumbsStop = stop;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { start(); } else { stop(); }
        });
      }, { threshold: 0.25 });
      io.observe(slider);
      slider._thumbsObserver = io;
    } else {
      start();
    }
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-card-thumbs]').forEach(initThumbs);
  }

  function teardown(root) {
    (root || document).querySelectorAll('[data-card-thumbs]').forEach(function (s) {
      if (typeof s._thumbsStop === 'function') s._thumbsStop();
      if (s._thumbsObserver) s._thumbsObserver.disconnect();
      s._thumbsStop = null;
      s._thumbsObserver = null;
      delete s.dataset.thumbsInit;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { teardown(e.target); });

  // Recommendations / recently load qua AJAX (<product-recommendations>) bắn 'currencyUpdate'
  // sau khi chèn card vào DOM — init slideshow cho các card mới (idempotent).
  document.addEventListener('currencyUpdate', function () { initAll(); });
})();
